import React from "react"
import { useIntl } from "react-intl"
import { Heading } from "@walmart-web/livingdesign-components"
import { collapseSideBar } from "context/applicationContext"
import ContextualHeader from "components/Shared/ContextualHeader"
import LivingDesignDatePicker from "components/Shared/LivingDesignDatePicker"
import {
	getDatabaseMonthDifference,
	getThreeDaysBeforeToday,
} from "helpers/temporal"
import NavigationTabs from "components/Shared/NavigationTabs"
import { createBreadcrumbs } from "./utils"
import {
	createTabs,
	TabTranslation,
} from "components/Shared/NavigationTabs/utils"
import "./index.scss"
import { FilterTypes } from "components/Shared/GlobalFilter/types"

type SubHeaderProps = {
	content?: React.ReactNode
	titleContent?: React.ReactNode
	newModuleContent?: React.ReactNode
	filters?: Array<FilterTypes>
	parentPath: string
	showDatePicker?: boolean
	filtersToShow?: Array<FilterTypes>
	subTitle: string
	tabs?: TabTranslation[]
	title: string
	onApplyFilters?: () => void
	globalFiltersPanelId?: string
	infoIcon?: React.ReactNode
}

const SubHeader: React.FC<SubHeaderProps> = ({
	title,
	subTitle,
	tabs = [],
	parentPath,
	showDatePicker = false,
	content,
	titleContent,
	newModuleContent,
	infoIcon = null,
}) => {
	collapseSideBar()
	const intl = useIntl()
	const initialDateValues = {
		from: getDatabaseMonthDifference(),
		to: getThreeDaysBeforeToday(),
	}
	const informationSubHeader = {
		title: title,
		subTitle: subTitle,
	}

	return (
		<div className="sub-header">
			<ContextualHeader
				breadcrumbs={createBreadcrumbs(intl, informationSubHeader, parentPath)}
			/>
			<div className="sub-header-title">
				<Heading role="sub-heading" UNSAFE_className="heading" as="h1">
					{intl.formatMessage({
						id: informationSubHeader.subTitle,
					})}
				</Heading>
				{infoIcon}
				<div className="new-module-tag">{newModuleContent}</div>
				<div className="sub-header-title-content">
					{showDatePicker && (
						<LivingDesignDatePicker
							maxInterval={30}
							initialValues={initialDateValues}
						/>
					)}
					{titleContent}
				</div>
			</div>
			{content}
			{tabs.length > 0 && <NavigationTabs tabs={createTabs(tabs, intl)} />}
		</div>
	)
}

export default SubHeader
